import { trackLink } from "../../../../../../services/analytics";
import getSingleItemProductString from "../getSingleItemProductString";
import { DELETE_ITEM_ACTION } from "../constants";
import {
  ADOBE_SAVED_ITEM_ACTION_KEY,
  ADOBE_PRODUCTS_KEY,
  ADOBE_DELETE_SAVED_ITEM_EVENT_KEY
} from "../../../../../../services/analytics/constants";

export const deleteItem = (state, { payload: { productId, variantId } }) => {
  const newState = {
    ...state,
    trackLink: {
      products: getSingleItemProductString({
        productId,
        variantId,
        quantity: 1
      }),
      savedItemAction: DELETE_ITEM_ACTION,
      events: [ADOBE_DELETE_SAVED_ITEM_EVENT_KEY],
      vars: [ADOBE_SAVED_ITEM_ACTION_KEY, ADOBE_PRODUCTS_KEY]
    }
  };

  trackLink({ state: newState });

  return newState;
};
